import { useMemo, useState } from 'react'
import type { JSX } from 'react'

import { TagsCombobox } from '~publish/components/TagsCombobox'
import { useTagsQuery } from '~publish/hooks/useTags'

import {
  useSelectedTagIds,
  useSetSelectedTagIds,
} from '../../store/postSlice/hooks'

import { TagSelectorButton } from './TagSelectorButton'

import styles from './TagSelector.module.css'

const MAX_TAGS_PER_POST = 10

export function TagSelector({
  maxVisibleTags = Infinity,
}: {
  maxVisibleTags?: number
}): JSX.Element {
  const { tags } = useTagsQuery()
  const selectedTagIds = useSelectedTagIds()
  const setSelectedTagIds = useSetSelectedTagIds()
  const [open, setOpen] = useState(false)
  const selectedTags = useMemo(
    () => tags.filter((tag) => selectedTagIds.includes(tag.id)),
    [tags, selectedTagIds],
  )

  return (
    <TagsCombobox
      open={open}
      selectedTags={selectedTagIds}
      onChange={setSelectedTagIds}
      onOpenChange={setOpen}
      limit={MAX_TAGS_PER_POST}
      align="start"
      showFooter={false}
      className={styles.tagsContent}
    >
      <TagSelectorButton
        tags={selectedTags.map((tag) => ({
          key: tag.id,
          name: tag.name,
          color: tag.color,
        }))}
        maxVisibleTags={maxVisibleTags}
      />
    </TagsCombobox>
  )
}
